import { IconName } from "halifax";
import { BenefitConfig, PerksConfig } from "./types";
import * as textConstants from "./textConstants";

const PREMIER_EXPERIENCE_CREDIT = {
  text: textConstants.getExperienceCreditText(100),
  icon: IconName.GiftVRShopBenefits,
};

const LIFESTYLE_EXPERIENCE_CREDIT = {
  text: textConstants.getExperienceCreditText(50),
  icon: IconName.GiftVRShopBenefits,
};

const DAILY_BREAKFAST = {
  text: textConstants.dailyBreakfastText,
  icon: IconName.KnifeForkPremierBenefits,
};

const PREMIER_HOTEL_MILES = {
  text: textConstants.getEarnMilesHotelsText(10),
  icon: IconName.TrophyVRShopBenefits,
};

const LIFESTYLE_HOTEL_MILES_VENTURE_X = {
  text: textConstants.getEarnMilesHotelsText(10),
  icon: IconName.TrophyVRShopBenefits,
};

const LIFESTYLE_HOTEL_MILES_VENTURE = {
  text: textConstants.getEarnMilesHotelsText(5),
  icon: IconName.TrophyVRShopBenefits,
};

const VACATION_RENTAL_MILES = {
  text: textConstants.getEarnMilesVRText(5),
  icon: IconName.TrophyVRShopBenefits,
};

// Mobile-only Benefits (no icons on mobile)
const MOBILE_PREMIER_EXPERIENCE_CREDIT = {
  text: textConstants.experienceCreditMobile,
};

const MOBILE_PREMIER_ROOM_UPGRADES = {
  text: textConstants.hotelRoomUpgradesMobile,
};

const MOBILE_LIFESTYLE_EXPERIENCE_CREDIT = {
  text: textConstants.lifestyleExperienceCreditMobile,
};

/**
 * PREMIER COLLECTION BENEFITS
 *
 * To modify what shows for each scenario:
 * - mobile: Benefits shown on mobile (no icons)
 * - hotels: Benefits shown for hotel stays on desktop
 * - vacationRentals: Benefits shown for vacation rental stays on desktop
 */
export const PREMIER_BENEFITS_CONFIG: BenefitConfig = {
  mobile: [
    MOBILE_PREMIER_EXPERIENCE_CREDIT,
    MOBILE_PREMIER_ROOM_UPGRADES,
  ],
  hotels: [
    PREMIER_EXPERIENCE_CREDIT,
    DAILY_BREAKFAST,
    PREMIER_HOTEL_MILES,
  ],
  vacationRentals: [
    PREMIER_EXPERIENCE_CREDIT,
    VACATION_RENTAL_MILES,
  ],
};

/**
 * LIFESTYLE COLLECTION BENEFITS
 *
 * Returns configuration based on card type (Venture X vs Venture).
 * To modify what shows for each scenario, adjust the arrays below.
 */
export const getLifestyleBenefitsConfig = (isVentureX: boolean): BenefitConfig => ({
  mobile: [
    MOBILE_LIFESTYLE_EXPERIENCE_CREDIT,
  ],
  hotels: [
    LIFESTYLE_EXPERIENCE_CREDIT,
    isVentureX ? LIFESTYLE_HOTEL_MILES_VENTURE_X : LIFESTYLE_HOTEL_MILES_VENTURE,
  ],
  vacationRentals: [
    LIFESTYLE_EXPERIENCE_CREDIT,
    VACATION_RENTAL_MILES,
  ],
});

export const PERKS_CONFIG: PerksConfig = {
  hotels: [
    {
      text: textConstants.roomUpgradePerk,
      icon: IconName.BedSideFilled,
      iconClassName: "room-upgrade-icon",
    },
    {
      text: textConstants.earlyCheckinPerk,
      icon: IconName.ClockPremierBenefits,
      iconClassName: "early-checkin-icon",
    },
    {
      text: textConstants.complimentaryFourthNightPerk,
      icon: IconName.StarPremierBenefits,
    },
  ],
  vacationRentals: [
    {
      text: textConstants.earlyCheckinPerk,
      icon: IconName.ClockPremierBenefits,
      iconClassName: "early-checkin-icon",
    },
  ],
};
